<template>
  <div class="how-active">
    <div class="ha-des">
      <p class="black">问：多账号管理是什么？如何进行多账号管理？</p>
      <p>答：多账号管理可以方便您快速便捷的从一个账号切换到另一个账号，类似于手机QQ中的切换账号功能，举个例子：如果您家里有两个孩子，分别是使用的爸爸和妈妈的手机号激活的课程，那么可以使用多账号管理让孩子在同一台手机上快速切换账号。<br>
进入”我的“页面的【设置】，再点击【多账号管理】，点击右上角的【添加】按钮，再输入您希望进行快速切换的号码以及该号码收到的验证码，最后点击右上角【保存】，就可添加成功。添加成功后，您以后就可以在”多账号管理“页面一键切换账号。</p>
<div class="ha-img">
      <img src="./img/multiple-account.png" alt="">
    </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  mounted(){

  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .how-active {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
</style>
